module.exports = __webpack_public_path__ + "fonts/7fd65ff0b890c8ea28a66d7e1c5ac621.svg";